import { Slot } from './task_template_slot';
export class Presentation {
    presentationType :string="INPUT"
    answerOptions:Slot[]=[]

}
